module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discover-nav"
  }, [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    staticClass: "justify-content-start",
    slot: "topHeader"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        active: _vm.isActiveTab(tab.id)
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v("\n              " + _vm._s(tab.title) + " ")])])
  }))])])], 2), _vm._v(" "), (_vm.currentUser) ? _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.onMobile,
      "content-class": [("my-genre-dialog ma-0 pa-2 " + (_vm.onMobile ? 'onMobile' : ''))]
    },
    model: {
      value: (_vm.show_genre_selector_dialog),
      callback: function($$v) {
        _vm.show_genre_selector_dialog = $$v
      },
      expression: "show_genre_selector_dialog"
    }
  }, [_c('genre-dialog', {
    attrs: {
      "dismiss": _vm.closeGenreSelectorDialog
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77fd02aa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/discoverNav.vue
// module id = 1786
// module chunks = 180